import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
export async function supportAction(input: Record<string, unknown>, operationId: string) {
  const result = await httpsCallable<Record<string, unknown>, { ticketId?: string; taskId?: string; number?: string; success?: boolean }>(functions, 'supportAction')({ ...input, operationId });
  return result.data;
}
export const newOperationId = () => crypto.randomUUID();
